import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { Add } from '@mui/icons-material';
import SkillRow from './SkillRow';
import { SkillsSectionProps, SkillEntry } from '../../types/profileForm.types';

const SkillsSection: React.FC<SkillsSectionProps> = ({
  skillEntries,
  errors,
  onChange,
  onBlur,
}) => {
  // const generateId = () => {
  //   return `skill_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
  // };

  const createEmptySkillEntry = (): SkillEntry => ({
    id: `skill_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`,
    skillName: '',
    experienceYears: 0,
    panIndia: true,
    selectedStates: [],
    description: '',
  });

  // Ensure at least one skill entry exists in the state
  React.useEffect(() => {
    if (skillEntries.length === 0) {
      onChange([createEmptySkillEntry()]);
    }
  }, [skillEntries.length, onChange]);

  const handleAddSkill = () => {
    const newSkillEntry = createEmptySkillEntry();
    const updatedSkillEntries = [...skillEntries, newSkillEntry];
    onChange(updatedSkillEntries);
  };

  const handleSkillChange = (index: number, updates: Partial<SkillEntry>) => {
    onChange((prevEntries: SkillEntry[]) =>
      prevEntries.map((skill, i) => (i === index ? { ...skill, ...updates } : skill))
    );
  };

  const handleRemoveSkill = (index: number) => {
    const updatedSkillEntries = skillEntries.filter((_, i) => i !== index);
    onChange(updatedSkillEntries);
  };
  // Ensure at least one skill entry exists
  // const displaySkillEntries = skillEntries.length > 0 ? skillEntries : [createEmptySkillEntry()];
  const displaySkillEntries = skillEntries;

  // Get already selected skills to exclude from other dropdowns
  const getExcludedSkills = (currentIndex: number) => {
    return skillEntries
      .filter((_, index) => index !== currentIndex)
      .map(skill => skill.skillName)
      .filter(Boolean);
  };

  return (
    <Box sx={{ mb: 2 }}>
      <Typography
        variant="h6"
        sx={{
          fontSize: '16px',
          fontWeight: 600,
          color: '#212529',
          mb: 2,
        }}
      >
        Professional Expertise
      </Typography>

      {displaySkillEntries.map((skillEntry, index) => (
        <SkillRow
          key={skillEntry.id}
          skillEntry={skillEntry}
          errors={errors?.[skillEntry.id]}
          canRemove={skillEntries.length > 1}
          onChange={(updates) => handleSkillChange(index, updates)}
          onRemove={() => handleRemoveSkill(index)}
          onBlur={onBlur}
        />
      ))}

      <Box sx={{ display: 'flex', justifyContent: 'flex-start', mt: 2 }}>
        <Button
          variant="outlined"
          startIcon={<Add />}
          onClick={handleAddSkill}
          sx={{
            borderColor: '#007bff',
            color: '#007bff',
            '&:hover': {
              backgroundColor: '#e7f1ff',
              borderColor: '#0056b3',
              color: '#0056b3',
            },
          }}
        >
          Add More Expertise
        </Button>
      </Box>
    </Box>
  );
};

export default SkillsSection;